import { type IconName } from '@/components';
import { ROUTES } from '@/types/enums';
import { ticketLabels } from '@/utils';

type MenuNavigationItem = {
  id: string;
  label: string;
  icon: IconName;
  href: string;
};

export const menuNavigation: MenuNavigationItem[] = [
  {
    id: 'home',
    label: 'Início',
    icon: 'Home',
    href: ROUTES.Enum['/'],
  },
  {
    id: 'my-tickets',
    label: ticketLabels.myTickets,
    icon: 'Tickets',
    href: ROUTES.Enum['/meus-titulos'],
  },
  {
    id: 'my-wallet',
    label: 'Minhas Premiações',
    icon: 'Wallet',
    href: ROUTES.Enum['/checkout'],
  },
  {
    id: 'last-results',
    label: 'Últimos Resultados',
    icon: 'Trophy',
    href: ROUTES.Enum['/resultados'],
  },
  {
    id: 'about-us',
    label: 'Sobre Nós',
    icon: 'Info',
    href: ROUTES.Enum['/sobre-nos'],
  },
  {
    id: 'support',
    label: 'Suporte',
    icon: 'Support',
    href: ROUTES.Enum['/suporte'],
  },
  // {
  //   id: 'help',
  //   label: 'Ajuda',
  //   icon: 'Help',
  //   href: ROUTES.Enum['/checkout'],
  // },
];
